<template>
  <div class="campaign-event-list">
    <CampaignEventListItem
      v-for="listItem in eventList"
      :key="listItem.event_id"
      :listItem="listItem"
      :selected="listItem.event_id === currentEventId"
    />
  </div>
</template>

<script>
/* eslint-disable */
import CampaignEventListItem from './CampaignEventListItem.vue';
export default {
  name: "CampaignEventList",
  components: { CampaignEventListItem },
  props: {
    currentEventId: String,
    eventList: Array,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.campaign-event-list {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}
</style>
